<template>
  <div class="purchase-summary-list">
    <div v-if="subtotal !== total">
      <span class="purchase-summary-list-title">{{ $t('payment.subtotal') }}</span>
      <span class="purchase-summary-list-amount text-secondary">{{ currencyFormat(subtotal) }}</span>
    </div>
    <div
      v-if="upgradeAmount"
      class="discount-item"
    >
      <span class="purchase-summary-list-title">{{ $t('subscription.upgrade') }}</span>
      <span class="purchase-summary-list-amount text-secondary">- {{ currencyFormat(upgradeAmount) }}</span>
    </div>
    <div
      v-if="discount"
      class="discount-item"
    >
      <span class="purchase-summary-list-title">{{ $t('coupons.discount') }}</span>
      <span class="purchase-summary-list-amount text-secondary">- {{ currencyFormat(discount) }}</span>
    </div>
    <div>
      <span class="purchase-summary-list-title">{{ $t('payment.total') }}</span>
      <span class="purchase-summary-list-amount text-secondary">{{ currencyFormat(total) }}</span>
    </div>
  </div>
</template>

<script>
import currency from 'currency.js'

export default {
  name: 'PurchaseSummaryList',
  props: {
    total: {
      type: Number,
      default: 0,
    },
    subtotal: {
      type: Number,
      default: 0,
    },
    discount: {
      type: Number,
      default: 0,
    },
    upgradeAmount: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    currencyFormat(value) {
      return currency(value, { precision: 2 }).format()
    },
  },
}
</script>

<style lang="scss">
.purchase-summary-list {
  & > div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 27px 40px 29px;

    &.discount-item {
      background-color: var(--light-gray);
    }

    .purchase-summary-list-title {
      font-size: 18px;
      line-height: 1.56;
      color: var(--description-color);
    }

    .purchase-summary-list-amount {
      font-size: 20px;
      font-weight: 600;
      line-height: 1.75;
    }

  }
}
</style>
